import Sidebar from './Sidebar';
import Navbar from './Navbar';
import './style.css';
import Table from 'react-bootstrap/Table';
import { Link } from "react-router-dom";

import React, { useEffect, useState } from 'react';
import axios from 'axios';

const ViewAllClient = () => {
    const [clients, setClients] = useState([]);
    const [editingClientId, setEditingClientId] = useState(null); // Track which client is being edited
    const [editClient, setEditClient] = useState({
        id: '',
        clientName: '',
        status: '',
        address: '',
        email: '',
        mobile: '',
        opening_balance: 0,
    });

    useEffect(() => {
        // Fetch the list of all clients from the API
        axios.get('https://react-apis.dotlocalhost.com/getAllClients.php')
            .then(response => {
                setClients(response.data);
            })
            .catch(error => {
                console.error('Error fetching clients:', error);
            });
    }, []);

    useEffect(() => {
        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("clnt");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("vclient");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }        

        // Fetch users when component mounts
        

        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }            
        };
    }, []); // Empty dependency array ensures this effect runs only once

    // Handle Edit button click to populate the form with the selected client's details
    const handleEdit = (client) => {
        setEditClient(client);
        setEditingClientId(client.id);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this client?")) {
            axios.post('https://react-apis.dotlocalhost.com/deleteClient.php', { id })
                .then(response => {
                    if (response.data.success) {
                        setClients(clients.filter(client => client.id !== id)); // Remove deleted client from list
                    } else {
                        alert('Failed to delete client');
                    }
                })
                .catch(error => {
                    console.error('Error deleting client:', error);
                });
        }
    };

    // Handle form input changes (editable fields)
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditClient(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Handle cancel edit (revert to original values)
    const handleCancelEdit = () => {
        setEditingClientId(null);  // Hide the edit form
    };

    // Handle update button click (save the updated client details)
    const handleUpdate = () => {
        axios.post('https://react-apis.dotlocalhost.com/updateClient.php', editClient)
            .then(response => {
                if (response.data.success) {
                    // Update the client list with the updated details
                    setClients(prevClients =>
                        prevClients.map(client =>
                            client.id === editClient.id ? editClient : client
                        )
                    );
                    setEditingClientId(null); // Hide the edit form after update
                } else {
                    alert('Failed to update client');
                }
            })
            .catch(error => {
                console.error('Error updating client:', error);
            });
    };

    return (
        <div className="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />
                <div className='ineerBody'>
                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>View All Clients</h3>
                        </div>
                    </div>
                    <div>
                        <Table striped bordered hover style={{ fontSize: '12px' }}>
                            <thead>
                                <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                    <th>Date</th>
                                    <th>Client Name</th>
                                    <th>Status</th>
                                    <th>Address</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                    <th>Opening Balance</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {clients.map(client => (
                                    <React.Fragment key={client.id}>
                                        <tr>
                                            <td>{client.date}</td>
                                            <td>{client.clientName}</td>
                                            <td>{client.status}</td>
                                            <td>{client.address}</td>
                                            <td>{client.email}</td>
                                            <td>{client.mobile}</td>
                                            <td>{client.opening_balance}</td>
                                            <td>
                                                <button class="btn btn-warning" style={{ marginRight: "10px", fontSize: "10px" }} onClick={() => handleEdit(client)}>Edit</button>
                                                <button className="btn btn-danger" style={{ fontSize: "10px" }} onClick={() => handleDelete(client.id)}>Delete</button>
                                            </td>
                                        </tr>

                                        {/* Editable form for the selected client */}
                                        {editingClientId === client.id && (
                                            <tr>
                                                <td colSpan="7" style={{ backgroundColor: '#f9f9f9' }}>
                                                    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                                                        <h5 style={{ marginTop: '40px', marginBottom: '0px', color: '#000000', fontSize: '18px', fontWeight: '500', border:'1px solid #447988', backgroundColor:'#C0D4D9', width:'30%', padding:'5px', textAlign:'center' }}>Edit details of {client.clientName}</h5>
                                                        <form>
                                                            <div className='row'>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Date</label>
                                                                    <input className='form-control' type="date" name="clientName" value={editClient.date} onChange={handleInputChange} />
                                                                </div>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Client Name</label>
                                                                    <input className='form-control' type="text" name="clientName" value={editClient.clientName} onChange={handleInputChange} />
                                                                </div>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Status</label>
                                                                    <input className='form-control' type="text" name="status" value={editClient.status} onChange={handleInputChange} />
                                                                </div>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Address</label>
                                                                    <input className='form-control' type="text" name="address" value={editClient.address} onChange={handleInputChange} />
                                                                </div>                                                                
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Email</label>
                                                                    <input className='form-control' type="email" name="email" value={editClient.email} onChange={handleInputChange} />
                                                                </div>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Mobile</label>
                                                                    <input className='form-control' type="text" name="mobile" value={editClient.mobile} onChange={handleInputChange} />
                                                                </div>
                                                                <div className='col-3'>
                                                                    <label class="form-label">Opening Balance</label>
                                                                    <input className='form-control' type="number" name="opening_balance" value={editClient.opening_balance} onChange={handleInputChange} />
                                                                </div>
                                                            </div>
                                                        </form>
                                                        <div className='row'>
                                                            <div className='col-3'>
                                                                <button class="btn btn-primary" style={{ marginRight: "10px", fontSize: "10px" }} onClick={handleUpdate}>Update</button>
                                                                <button class="btn btn-danger" style={{ marginRight: "10px", fontSize: "10px" }} onClick={handleCancelEdit}>Cancel</button>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ViewAllClient;
